import styled from '@emotion/styled'
import { AnimatePresence, motion } from 'framer-motion'
import React, { memo } from 'react'
import { useInView } from 'react-intersection-observer'

export interface Props {
  className?: string
  children: any
  delay?: number
  duration?: number
  y?: number
  onClick?: () => void
  threshold?: number
}

export const FadeInUp = memo(function FadeInUp({
  className,
  children,
  delay,
  duration = 1.6,
  y = 90,
  onClick,
  threshold = 0.4,
}: Props) {
  const [ref, isVisible] = useInView({
    threshold,
    triggerOnce: true,
  })

  const variants = {
    visible: {
      opacity: 1,
      rotate: 0.02,
      y: 0,
      transition: {
        bounce: 0,
        delay,
        duration,
        type: 'spring',
      },
    },
    hidden: {
      delay: 0,
      opacity: 0,
      rotate: 0,
      y,
    },
  }

  return (
    <AnimatePresence mode="wait">
      <Container
        animate={isVisible ? 'visible' : 'hidden'}
        className={className}
        initial="hidden"
        onClick={onClick}
        ref={ref}
        variants={variants}
      >
        {children}
      </Container>
    </AnimatePresence>
  )
})

const Container = styled(motion.div)`
  will-change: transform;
`
